import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { styled } from '@mui/material/styles';
import { LinkElement } from '@plugins/next-cms-core';

const StyledLink = styled('a')(() => ({
  opacity: 0.75,
  transition: 'opacity 250ms ease-in-out',
  '&:hover, &:focus': {
    opacity: 1,
  },
}));

export default function FooterMenu(props) {
  const { items, onChangeConsent } = props;

  return items.map((item) => (
    <Typography
      key={item.id}
      color="secondary"
      component="div"
      sx={{ mb: 2 }}
      variant="body2"
    >
      <FooterMenuLink item={item} onChangeConsent={onChangeConsent} />
    </Typography>
  ));
}

function FooterMenuLink({ item, onChangeConsent }) {
  const { cssClass, isConsentLink, label } = item;

  // Opens the consent manager instead of navigating. Deliberately not wrapped in
  // LinkElement: that component destructures `onClick` out of its props and never
  // applies it, so the handler would be silently dropped.
  if (isConsentLink) {
    return (
      <StyledLink className={cssClass} href="#" onClick={onChangeConsent}>
        {label}
      </StyledLink>
    );
  }

  // A link the editor left without a target renders as plain text. Passing a null
  // `data` to LinkElement would throw — useContentElement rejects nil and
  // defaultProps do not apply to null — taking the footer down on every page.
  if (!item.link) {
    return <span className={cssClass}>{label}</span>;
  }

  return (
    <LinkElement data={item.link}>
      <StyledLink className={cssClass}>{label}</StyledLink>
    </LinkElement>
  );
}

const itemShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  cssClass: PropTypes.string,
  isConsentLink: PropTypes.bool,
  link: PropTypes.shape({
    resolvedUrl: PropTypes.string,
    isNewWindow: PropTypes.bool,
  }),
});

FooterMenuLink.propTypes = {
  item: itemShape.isRequired,
  onChangeConsent: PropTypes.func,
};

FooterMenu.propTypes = {
  items: PropTypes.arrayOf(itemShape),
  onChangeConsent: PropTypes.func,
};
